import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  modalCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalFloating: {
    display: 'flex',
    alignItems: 'flex-end', // Alinha na base
    justifyContent: 'flex-end', // Alinha na esquerda
    paddingBottom: '160px', // Ajuste essa altura conforme o tamanho do seu FAB aberto
    paddingLeft: '20px',    // Distância da borda esquerda
  },
  pickerContainer: {
    outline: 'none',
    boxShadow: theme.shadows[10],
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  }
}))
